import { render, staticRenderFns } from "./renew-record.vue?vue&type=template&id=836f901e&scoped=true"
import script from "./renew-record.vue?vue&type=script&lang=ts"
export * from "./renew-record.vue?vue&type=script&lang=ts"
import style0 from "./renew-record.vue?vue&type=style&index=0&id=836f901e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "836f901e",
  null
  
)

export default component.exports